module.exports = __webpack_public_path__ + "img/bjx_d_12.6528cb8d.png";